// extracted by mini-css-extract-plugin
export var SectionWrapper = "ServicesGrid-module--SectionWrapper--1-wNP";
export var ImageWrapper = "ServicesGrid-module--ImageWrapper--3e0lJ";
export var Article = "ServicesGrid-module--Article--27ok4";
export var ReversedArticle = "ServicesGrid-module--ReversedArticle--2hbBc";
export var ContentWrapper = "ServicesGrid-module--ContentWrapper--27QEB";
export var CustomParagraph = "ServicesGrid-module--CustomParagraph--2DeiF";
export var CustomHeader = "ServicesGrid-module--CustomHeader--165dz";